module.exports = __webpack_public_path__ + "static/WEDDING E&M-422-f5bb8e91a562267a7b8e33320dc7ed5b.jpg";